<template>
  <button @click="open" class="btn btn-sm btn-success mr-1 mb-1">
    <font-awesome-icon icon="cog"/>&nbsp;{{ $t('setup') }}
    <b-modal v-model="showForm" :title="$t('setup')" no-close-on-backdrop no-enforce-focus>
    <div class="modal-content">
      <div class="modal-body">
        <form>
          <client-select :label="$t('client')" :model="formModel" attribute="client"
                         :errors="formErrors"></client-select>
          <admin-user-select :label="$t('sales')" :model="formModel" attribute="sales" :errors="formErrors"
                             :place-holder="$t('chooseSale')" v-if="formModel.client"></admin-user-select>
          <template v-if="formModel.sales">
            <p>
              <b>{{$t('supervisor')}}: </b>
              <span v-if="getSupervisorLoading"><b-spinner small></b-spinner></span>
              <span v-else-if="supervisor">{{supervisor.name}}</span>
              <span v-else>{{$t('noSupervisorFound')}}</span>
            </p>
            <p>
              <b>{{$t('manager')}}: </b>
              <span v-if="getManagerLoading"><b-spinner small></b-spinner></span>
              <span v-else-if="manager">{{manager.name}}</span>
              <span v-else>{{$t('noManagerFound')}}</span>
            </p>
          </template>
          <form-input :label="$t('amount')" attribute="total" :model="formModel" :errors="formErrors"></form-input>
          <form-input :label="$t('note')" attribute="note" :model="formModel" :errors="formErrors"></form-input>
          <label>{{ $t('total') }}</label>: <span>{{ formModel.total | numFormat }}</span>
        </form>
      </div>
    </div>
    <template v-slot:modal-footer>
      <button class="btn btn-secondary float-right" @click="showForm = false">{{ $t('cancel') }}</button>
      <button :disabled="formModel.total <=0 || !formModel.client" class="btn btn-primary float-right" @click="purchase()">
        {{ $t('savePlanOrder') }}
      </button>
    </template>
  </b-modal>
  </button>
</template>
<script>
import CRUD from "@/mixins/CRUD";
import ClientSelect from "../../../components/ClientSelect";
import AdminUserSelect from "../../../components/AdminUserSelect";

export default {
  components: {AdminUserSelect, ClientSelect},
  mixins: [CRUD],
  data: function () {
    return {
      service: '/plan-order',
      defaultFormModel: {
        client: null,
        sales: null,
        total: 0
      },
      sales: null,
      supervisor: null,
      manager: null,
      getSupervisorLoading: false,
      getManagerLoading: false
    }
  },
  methods: {
    open: function () {
      this.showForm = true;
      this.formModel = {};
      this.formModel = Object.assign({}, this.formModel, this.defaultFormModel);
    },
    purchase() {
      let loader = this.$loading.show();
      this.$service({url: '/plan-order/setup/', method: 'post', data: this.formModel}).then(response => {
        this.showForm = false;
        if (response.data) {
          this.$swal({
            title: this.$t('success'),
            icon: 'success',
            toast: true,
            position: 'top-end',
            timer: 5000,
          });
          this.$bus.$emit('planOrder');
          this.$bus.$emit('loadClient');
        } else {
          this.$swal({
            title: this.$t('error'),
            icon: 'error'
          });
        }
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
          this.showForm = false;
        } else {
          this.formErrors = error.response.data;
        }
      }).finally(() => {
        loader.hide();
      });
    },
    getSales() {
      this.$service.get('/admin-user/' + this.formModel.sales).then(response => {
        this.sales = response.data;
      })
    },
    getSupervisor() {
      this.getSupervisorLoading = true;
      this.$service.get('/admin-user', {
        params: {
          page: 1,
          pageSize: 100,
          role: 'supervisor',
          group: this.sales.group
        }
      }).then(response => {
        if (response.data && response.data.docs.length) {
          this.supervisor = response.data.docs[0];
        }
      }).finally(() => {
        this.getSupervisorLoading = false;
      })
    },
    getManager() {
      this.getManagerLoading = true;
      this.$service.get('/admin-user', {
        params: {
          page: 1,
          pageSize: 100,
          role: 'manager',
          department: this.sales.department
        }
      }).then(response => {
        if (response.data && response.data.docs.length) {
          this.manager = response.data.docs[0];
        }
      }).finally(() => {
        this.getManagerLoading = false;
      })
    },
  },
  watch: {
    "formModel.sales": {
      handler(val) {
        this.supervisor = null;
        this.getSupervisorLoading = true;
        this.manager = null;
        this.getManagerLoading = true;
        if (val) {
          this.getSales();
        }
      }
    },
    "sales": {
      handler(val) {
        if (val) {
          if (val.group) {
            this.getSupervisor();
          } else {
            this.getSupervisorLoading = false;
          }
          if (val.department) {
            this.getManager();
          } else {
            this.getManagerLoading = false;
          }
        }
      }
    }
  },
  i18n: {
    messages: {
      vi: {
        cancel: 'Huỷ',
        savePlanOrder: 'Lưu đơn hàng',
        sales: 'Nhân viên sales',
        noSales: 'Không có nhân viên sales',
        account: 'Nhân viên account',
        noAccount: 'Không có nhân viên account',
        supervisor: 'Trưởng nhóm',
        noSupervisorFound: 'Không tìm thấy trưởng nhóm',
        manager: 'Trưởng phòng',
        noManagerFound: 'Không tìm thấy trưởng phòng',
        chooseSale: 'Chọn nhân viên sales',
        setup: 'Phí cài đặt',
        amount: 'Số tiền',
        note: 'Ghi chú'
      },
      en: {
        cancel: 'Cancel',
        savePlanOrder: 'Save plan order',
        sales: 'Sales person',
        noSales: 'No sales person',
        account: 'Account',
        noAccount: 'No sales account',
        supervisor: 'Supervisor',
        noSupervisorFound: 'No supervisor found',
        manager: 'Manager',
        noManagerFound: 'No manager found',
        chooseSale: 'Select pos person',
        setup: 'Setup fee',
        amount: 'Amount',
        note: 'Note'
      }
    }
  }
}
</script>